import './CollapsableCategory.scss';

import React, { useCallback, useEffect, useState } from 'react';

import CollapsableArea from '../CollapsableArea/CollapsableArea';
import SideFlag from '../SideFlag';

const CollapsableCategory = props => {
    const {className = '', style, flagColor, title, children, collapsable = true, expanded = false, disabled = false, onChange} = props,
        [isExpanded, setExpanded] = useState(collapsable ? true : expanded),
        classes = [
            'CollapsableCategory',
            className,
            collapsable ? 'collapsable' : '',
            disabled ? 'disabled' : '',
            expanded || !collapsable ? 'expanded' : 'collapsed',
        ]
        ;

    // react to prop changes
    useEffect(() => {
        setExpanded(expanded);
    }, [expanded]);

    // callbacks
    const handleClick = useCallback(() => {
        const nextExpandedState = collapsable ? !expanded : true;
        setExpanded(nextExpandedState);
        if (onChange) onChange(nextExpandedState);
    }, [collapsable, expanded, onChange]);

    // Output
    return (
        <div className={classes.join(' ')} style={style}>
            <div className="title" onClick={handleClick}>
                <SideFlag color={flagColor} /> {title}
                <div className="icon expanded-status"></div>
            </div>
            <CollapsableArea expanded={expanded || !collapsable}>{children}</CollapsableArea>
        </div>
    );
};

export default CollapsableCategory;
